import { AbstractControl } from '@angular/forms';

export function ValidateHin(control: AbstractControl) {
  const hin: string = control.value;

  if (!/^[a-zA-Z]{4}\s?[0-9]{4}\s?[0-9]{4}$/.test(hin)) {
    return { validHin: false };
  }

  return null;
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/validators/hin.validator.ts